import { de } from './messages/de.js';
import { en } from './messages/en.js';
import { fr } from './messages/fr.js';

/**
 * Die Sprache ausserhalb von React.
 *
 * `useTranslation()` gibt es nur innerhalb des Baums. Der Netzwerkabschnitt
 * braucht aber genau dort Text, wo es keinen Baum gibt: im Abfangjäger von
 * axios, wenn eine Anfrage scheitert. Ohne diese Stelle bliebe dort nur die
 * Meldung von axios übrig - "Network Error", "timeout of 20000ms exceeded",
 * "Request failed with status code 429". Alle drei sind englisch, und keine
 * sagt einem Menschen, was er jetzt tun soll.
 *
 * Die Wörterbücher und die Erkennung stehen deshalb HIER und werden vom
 * LanguageContext mitbenutzt - nicht umgekehrt. Sonst gäbe es zwei
 * Erkennungen, die auseinanderlaufen können.
 */

export const SPRACHEN = ['de', 'en', 'fr'];
export const RUECKFALL = 'de';
export const SPEICHER_SCHLUESSEL = 'recica.locale';

export const WOERTERBUECHER = { de, en, fr };

/** Gespeicherte Wahl, sonst Browsersprache, sonst Deutsch. */
export function erkenneSprache() {
  if (typeof window === 'undefined') {
    return RUECKFALL;
  }
  try {
    const gespeichert = window.localStorage.getItem(SPEICHER_SCHLUESSEL);
    if (SPRACHEN.includes(gespeichert)) {
      return gespeichert;
    }
  } catch {
    // Ein gesperrter Speicher ist kein Grund, die Anwendung anzuhalten.
  }
  const angeboten = window.navigator?.languages || [window.navigator?.language || ''];
  for (const roh of angeboten) {
    const code = String(roh).slice(0, 2).toLowerCase();
    if (SPRACHEN.includes(code)) {
      return code;
    }
  }
  return RUECKFALL;
}

/* Was der LanguageProvider zuletzt gesetzt hat. Vor dem ersten Rendern ist
   das null - dann wird erkannt, und zwar gleich wie im Provider. */
let aktiv = null;

export function setzeSprache(sprache) {
  if (SPRACHEN.includes(sprache)) {
    aktiv = sprache;
  }
}

export function aktiveSprache() {
  return aktiv || erkenneSprache();
}

/** Wie `t()`, nur ohne Baum - gleiche Schlüssel, gleiche {var}-Einsetzung. */
export function uebersetze(schluessel, vars) {
  const woerter = WOERTERBUECHER[aktiveSprache()] || WOERTERBUECHER[RUECKFALL];
  const roh = woerter[schluessel] ?? WOERTERBUECHER[RUECKFALL][schluessel] ?? schluessel;
  if (!vars) {
    return roh;
  }
  return roh.replace(/\{(\w+)\}/g, (_, k) => (k in vars ? String(vars[k]) : `{${k}}`));
}
